import { render, staticRenderFns } from "./FormationConfig.vue?vue&type=template&id=7497bd6c&"
import script from "./FormationConfig.vue?vue&type=script&lang=js&"
export * from "./FormationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports